// Generated from packages/shared/design-tokens/recipes.tokens.json, core.json and foundations.json. Run pnpm tokens:build; do not edit.
export const DESIGN_RECIPES = {
    "color": {
        "text": "#141414",
        "secondary": "#4b5563",
        "muted": "#6b7280",
        "canvas": "#ffffff",
        "surface": "#ffffff",
        "subtle": "#f9fafb",
        "hover": "#f3f4f6",
        "border": "#e5e7eb",
        "action": "#3468f8",
        "actionHover": "#2952d6",
        "focus": "#3468f8",
        "danger": "#991b1b",
        "success": "#047857",
        "successBackground": "#e8f8f0",
        "warning": "#854d0e",
        "warningBackground": "#fef6e0",
        "dangerBackground": "#fef2f2",
        "dangerBorder": "#fecaca",
        "attention": "#dc2626",
        "dangerAction": "#dc2626",
        "dangerActionHover": "#b91c1c",
        "groundDot": "rgba(107, 114, 128, 0.09)"
    },
    "spacing": {
        "inline": "4px",
        "related": "8px",
        "field": "12px",
        "card": "16px",
        "panel": "16px",
        "section": "24px",
        "page": "32px"
    },
    "width": {
        "dialog-compact": "24rem",
        "dialog-standard": "28rem",
        "dialog-wide": "36rem"
    },
    "corner": {
        "compact": "4px",
        "control": "6px",
        "panel": "8px",
        "dialog": "12px",
        "pill": "9999px"
    },
    "elevation": {
        "sm": "0px 1px 3px 0px rgb(6.2745% 9.4118% 15.686% / 0.06)",
        "hover": "0px 4px 12px 0px rgb(6.2745% 9.4118% 15.686% / 0.08), 0px 1px 3px 0px rgb(6.2745% 9.4118% 15.686% / 0.05)",
        "popover": "0px 4px 12px 0px rgb(0% 0% 0% / 0.1)",
        "dialog": "0px 25px 50px -12px rgb(0% 0% 0% / 0.25)",
        "focus": "0px 0px 2px 0px rgb(20.392% 40.784% 97.255%)",
        "focusDanger": "0px 0px 2px 0px rgb(93.725% 26.667% 26.667%)"
    },
    "motion": {
        "loading": "0.8s",
        "feedback": "0.15s",
        "transition": "0.2s",
        "reveal": "0.26s",
        "moment": "0.7s",
        "easeOut": "cubic-bezier(0.16, 1, 0.3, 1)",
        "easeMove": "cubic-bezier(0.77, 0, 0.175, 1)"
    },
    "border": {
        "thin": "1px",
        "focus": "2px"
    },
    "icon": {
        "compact": "14px",
        "standard": "16px",
        "prominent": "20px"
    },
    "text": {
        "micro": {
            "fontFamily": "inherit",
            "fontSize": "10px",
            "fontWeight": 500,
            "lineHeight": "12px",
            "letterSpacing": "0px"
        },
        "caption": {
            "fontFamily": "inherit",
            "fontSize": "12px",
            "fontWeight": 400,
            "lineHeight": "16px",
            "letterSpacing": "0px"
        },
        "label": {
            "fontFamily": "inherit",
            "fontSize": "12px",
            "fontWeight": 500,
            "lineHeight": "16px",
            "letterSpacing": "0px"
        },
        "bodySmall": {
            "fontFamily": "inherit",
            "fontSize": "12px",
            "fontWeight": 400,
            "lineHeight": "16px",
            "letterSpacing": "0px"
        },
        "body": {
            "fontFamily": "inherit",
            "fontSize": "14px",
            "fontWeight": 400,
            "lineHeight": "20px",
            "letterSpacing": "0px"
        },
        "bodyCompact": {
            "fontFamily": "inherit",
            "fontSize": "14px",
            "fontWeight": 400,
            "lineHeight": "20px",
            "letterSpacing": "0px"
        },
        "heading": {
            "fontFamily": "inherit",
            "fontSize": "14px",
            "fontWeight": 600,
            "lineHeight": "20px",
            "letterSpacing": "0px"
        },
        "title": {
            "fontFamily": "inherit",
            "fontSize": "20px",
            "fontWeight": 600,
            "lineHeight": "28px",
            "letterSpacing": "0px"
        },
        "section": {
            "fontFamily": "inherit",
            "fontSize": "20px",
            "fontWeight": 600,
            "lineHeight": "28px",
            "letterSpacing": "0px"
        },
        "titleLarge": {
            "fontFamily": "inherit",
            "fontSize": "28px",
            "fontWeight": 700,
            "lineHeight": "36px",
            "letterSpacing": "0px"
        },
        "page": {
            "fontFamily": "inherit",
            "fontSize": "28px",
            "fontWeight": 700,
            "lineHeight": "36px",
            "letterSpacing": "0px"
        },
        "display": {
            "fontFamily": "inherit",
            "fontSize": "36px",
            "fontWeight": 700,
            "lineHeight": "40px",
            "letterSpacing": "0px"
        },
        "metric": {
            "fontFamily": "inherit",
            "fontSize": "28px",
            "fontWeight": 700,
            "lineHeight": "32px",
            "letterSpacing": "0px"
        },
        "prose": {
            "fontFamily": "inherit",
            "fontSize": "16px",
            "fontWeight": 400,
            "lineHeight": "24px",
            "letterSpacing": "0px"
        },
        "code": {
            "fontFamily": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
            "fontSize": "12px",
            "fontWeight": 400,
            "lineHeight": "20px",
            "letterSpacing": "0px"
        }
    }
};
//# sourceMappingURL=designRecipes.js.map